import { Component } from "@angular/core";
import { MenuController, PopoverController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { UserDataService } from "src/app/services/user/user.service";
import {
  customerDimensionsPermissions,
  productsDimensionsPermissions,
} from "src/app/utils/dimensionstypes";
import { ROUTES } from "src/app/utils/routes";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { SideMenuService } from "./side-menu.service";

export const administrationPagePermissions = [
  "view_administrator_access_roles",
  "view_administrator_access_permissions",
  "view_administrator_access_users",
  "view_administrator_settings_application",
  "view_administrator_settings_locations",
  "view_administrator_settings_documents",
  "view_administrator_settings_user_settings",
];

export const reportsPageRoutes = [
  "view_reports_customer_orders_customer_orders_summary",
  "view_reports_customer_orders_customer_orders_detail",
  "view_reports_customer_orders_customer_orders_fill_rate",
  "view_reports_customer_orders_customer_orders_timeline",
  "view_reports_customer_orders_customer_orders_nat.accounts",
  "view_reports_inventory_control_products_availability",
  "view_reports_inventory_control_inventory_transactions",
  "view_reports_inventory_control_inventory_by_site",
  "view_reports_inventory_control_shelf_life_by_site",
  "view_reports_inventory_control_purchase_order_fill_rate",
  "view_reports_inventory_control_missed_fulfillment",
  "view_reports_inventory_control_missied_fulfillment",
  "view_reports_charts_net_sales_by_dimension",
  "view_reports_exports_sales",
  "view_reports_exports_open_balance",
  "view_reports_exports_sales_analysis",
  "view_reports_exports_help_analytics",
  "view_reports_audit_customer_orders_state",
  "view_reports_audit_audit_trail",
];

export const dashboardPagePermissions = [
  "view_dashboard_customer_orders_customer_orders",
  "view_dashboard_inventory_control_products_availability",
  "view_dashboard_inventory_control_inventory_by_site",
  "view_dashboard_inventory_control_shelf_life_by_site",
  "view_dashboard_customer_orders_geo_location",
];

export const customerOrderPagePermissions = [
  "view_customer_orders_sales_operations_customer_orders",
  "view_customer_orders_sales_operations_credits",
  "view_customer_orders_sales_operations_delivered_shelf_life",
];

export const operationsPagePermissions = [
  "view_operations_inventory_picking",
  "view_operations_inventory_receiving",
  "view_operations_inventory_work_order",
  "view_operations_inventory_returns",
  "view_operations_inventory_estimated_sales",
  "view_operations_inventory_inventory_transactions",
  "view_operations_inventory_transfer_inventory",
  "view_operations_shelf_life_management_fresh_shelf",
  "view_operations_labels_conversion",
  "view_operations_labels_re_labeling",
  "view_operations_labels_labeling",
];

export const managePagePermissions = [
  "view_manage_maintenance_price_list",
  "view_manage_maintenance_customer_orders",
  "view_manage_maintenance_item_settings",
  "view_manage_maintenance_scan_documents",
  "view_manage_maintenance_traceability_control",
  "view_manage_inventory_counting_inventory_counting_list",
  "view_manage_inventory_counting_count_inventory",
  "view_manage_application_device_printer_assignment",
  "view_manage_application_sites",
  "view_manage_application_external_upc",
  "view_manage_application_label_templates",
  "view_manage_tools_barcode_tester",
  "view_manage_tools_ocr_tester",
  "create_manage_tools_task_process",
  "view_manage_tools_label_tester",
  "view_manage_products_repository_upload",
  "view_manage_products_repository_products",
];

@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.scss"],
})
export class SideMenuComponent {
  ROUTES = ROUTES;
  _subscription: Subscription | undefined;
  _ionMenu: any;
  _navWrapper: any;
  collapseIcon = "chevron-back-outline";
  permissions: string[] = [];
  canShowDimensionsLink: boolean;
  canShowAdminLink: boolean = false;
  canShowReportLink: boolean;
  dashboardPagePermissions: string[] = dashboardPagePermissions;
  operationsPagePermissions: string[] = operationsPagePermissions;
  managePagePermissions: string[] = managePagePermissions;
  customerOrderPagePermissions: string[] = customerOrderPagePermissions;

  constructor(
    private menu: MenuController,
    public userService: UserDataService,
    public popoverController: PopoverController,
    private sideMenuService: SideMenuService,
  ) {}

  async ngOnInit() {
    this._subscription = this.sideMenuService._toggleSidebar.subscribe(() => {
      this.toggleSidebar();
    });
    this._subscription.add(
      this.userService.permissions$.subscribe((permission) => {
        this.permissions = permission;
        if (this.permissions) {
          this.canShowDimensionsLink = this.permissions.some((itemToCheck) =>
            customerDimensionsPermissions
              .concat(productsDimensionsPermissions)
              .includes(itemToCheck),
          );
          this.canShowAdminLink = this.permissions.some((itemToCheck) =>
            administrationPagePermissions.includes(itemToCheck),
          );
          this.canShowReportLink = this.permissions.some((itemToCheck) =>
            reportsPageRoutes.includes(itemToCheck),
          );
        }
      }),
    );
  }

  ngAfterViewInit() {
    this._ionMenu = document.getElementsByTagName("ion-menu")[0];
    this._navWrapper = document.getElementsByClassName("nav-wrapper")[0];
  }

  ngOnDestroy() {
    this._subscription?.unsubscribe();
  }

  async dropdown(ev: any) {
    let popover = await this.popoverController.create({
      component: DropdownComponent,
      event: ev,
      mode: "ios",
      showBackdrop: false,
    });
    popover.present();
  }

  async toggleSidebar() {
    if (this.isMiniSidebar()) {
      this._ionMenu.classList.remove("mini-sidebar");
      this.collapseIcon = "chevron-back-outline";
    } else {
      this._ionMenu.classList.add("mini-sidebar");
      this.collapseIcon = "chevron-forward-outline";
    }
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event("resize"));
    }, 80);
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 100);
  }

  isMiniSidebar(): boolean {
    return this._ionMenu && this._ionMenu.classList.contains("mini-sidebar");
  }

  async refresh() {
    if (this.userService.token) {
      await this.userService.reloadUser();
    }
  }

  close() {
    this.menu.close();
  }
}
